import { sortedUniqBy, sortBy } from 'lodash';
import api from 'src/api';

const data = {
  sync: false,
  fetching: false,
  searchResult: [],
  terms: [],
  totalCount: undefined,
  currentFilter: undefined,
  error: false,
};

const actions = {
  searchActivities({ commit }, {
    searchQuery, moreData = false, page, pageSize,
  }) {
    commit('SET_FETCHING');
    if (moreData) {
      searchQuery.page += 1;
    }
    if (page) {
      searchQuery.page = page;
    }
    if (pageSize) {
      searchQuery.pageSize = pageSize;
    }
    return api.searchActivities(searchQuery).then((res) => {
      commit('SET_SEARCH_RESULT', {
        response: res,
        searchQuery,
        moreData,
      });
      return res;
    }).catch((err) => {
      let error = true;
      if (typeof err.message !== 'undefined') error = err.message;
      commit('SET_FETCHING_ERROR', error);
      throw err;
    });
  },
};

const mutations = {
  SET_SEARCH_RESULT(state, { response, searchQuery, moreData }) {
    if (moreData) {
      state.searchResult = state.searchResult.concat(response.activities.slice());
    } else {
      state.searchResult = response.activities.slice();
    }
    state.terms = response.terms.slice();
    state.totalCount = response.totalCount;
    state.currentFilter = JSON.parse(JSON.stringify(searchQuery));
    state.currentFilter.pageSize = searchQuery.pageSize || response.pageSize;
    if (searchQuery && searchQuery.messageBody) {
      state.terms.push(searchQuery.messageBody);
    }
    state.terms = sortedUniqBy(state.terms, (string) => string.toLowerCase());
    state.terms = sortBy(state.terms, (string) => string.length).reverse();
    state.fetching = false;
    state.error = false;
    state.sync = true;
  },
  SET_FETCHING(state) {
    state.fetching = true;
  },
  SET_FETCHING_ERROR(state, error) {
    state.fetching = false;
    state.error = error;
  },
  CLEAR_SEARCH_RESULT(state) {
    state.searchResult = [];
    state.totalCount = undefined;
    state.currentFilter = undefined;
  },
};

const store = {
  namespaced: true,
  state: data,
  actions,
  mutations,
};

export default store;
